import { Link } from 'react-router-dom';
import AccountShellLayout from '@/app/layout/AccountShellLayout';
import { playClawHomeUrl } from '@/lib/redirects';

const NotFoundPage = () => {
  const accountHomePath = '/';
  const accountHomeLabel = 'Go to account home';
  const playClawLinkLabel = 'Open Play Claw';
  const message = 'This page does not exist. Use your account home to sign in or manage your profile, or jump back into Play Claw.';

  return (
    <AccountShellLayout>
      <div className="empty-state">
        <p className="empty-state__eyebrow">404</p>
        <h1 className="empty-state__title">This page does not exist.</h1>
        <p className="empty-state__body">{message}</p>
        <div className="empty-state__actions">
          <Link className="button button--primary" to={accountHomePath}>
            {accountHomeLabel}
          </Link>
          <a className="button button--secondary" href={playClawHomeUrl}>
            {playClawLinkLabel}
          </a>
        </div>
      </div>
    </AccountShellLayout>
  );
};

export default NotFoundPage;
